import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';

import VariableType from 'app/admin/opcDaWriter/dto/VariableType';
import OpcDaWriterEditService from '../service/OpcDaWriterEditService';
import OpcDaWriterLogService from 'app/admin/opcDaWriterLog/service/OpcDaWriterLogService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'opcDaWriterEditForm',
		topic: 'opcDaWriter',
		service: OpcDaWriterEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'hostName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'serverName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'opcDaWriterLog',
					component: EditFormSelectField,
					required: true,
					items: () => OpcDaWriterLogService.getListSelection()
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null,
						tagName: null,
						expression: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => { return { label: VariableType[key], value: key }; })
						},
						{
							key: 'tagName',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'expression',
							component: EditFormTextField,
							dependsOn: 'type',
							required: true,
							visibleIf: type => type === 'Expression'
						}
					]
				}
			];

			return fields;
		}
	};
};

function OpcDaWriterEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(OpcDaWriterEditForm);
